import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import React, { Fragment } from 'react';
import { useLocation, useParams, useRoutes } from 'react-router-dom';

export interface BreadcrumbItemProps {
  text: string;
  link?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItemProps[];
}

const CustomBreadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const router = useLocation();


  const activeLink = (link: string) => {
    if (link === router.pathname) {
      return 'text-colorText';
    }

    if (router.pathname.includes(link)) {
      return 'text-colorText';
    }

    if (
      router.pathname.includes('edit-product') &&
      link.includes('edit-product')
    ) {
      return 'text-colorText';
    }

    return 'text-muted';
  };
  return (
    <Breadcrumb
      className='w-full flex'
      separator={<BreadcrumbSeparator> / </BreadcrumbSeparator>}
    >
      <BreadcrumbList className='flex flex-nowrap'>
        {items.map((item, index) => (
          <BreadcrumbItem key={index}>
            <BreadcrumbLink
              className={`${activeLink(item.link)} text-nowrap`}
              to={item.link || '#'}
            >
              {item.text}
            </BreadcrumbLink>
            {index < items.length - 1 && <BreadcrumbSeparator />}
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default CustomBreadcrumb;
